import flagbr from "../assets/images/flags/br.svg";

const languages = {
  br: {
    label: "Português (Brasil)",
    flag: flagbr,
  },
}

export default languages
